
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/navitas-professional",
      function () {
        return require("private-next-pages/navitas-professional.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/navitas-professional"])
      });
    }
  